import { Shield, Users, Award, Clock, Lock, Heart } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Card } from "@/components/ui/card";

interface TrustSignalsProps {
  className?: string;
}

export function TrustSignals({ className }: TrustSignalsProps) {
  return (
    <div className={`space-y-4 ${className}`}>
      {/* Security & Safety Badges */}
      <div className="flex flex-wrap items-center justify-center gap-3 mb-6">
        <Badge variant="teen-green" className="text-xs font-medium flex items-center gap-1">
          <Shield className="w-3 h-3" />
          HTTPS Secured
        </Badge>
        <Badge variant="teen-blue" className="text-xs font-medium flex items-center gap-1">
          <Users className="w-3 h-3" />
          Safe for Young Players
        </Badge>
        <Badge variant="teen-purple" className="text-xs font-medium flex items-center gap-1">
          <Lock className="w-3 h-3" />
          Privacy Protected
        </Badge>
        <Badge variant="teen-gold" className="text-xs font-medium flex items-center gap-1">
          <Award className="w-3 h-3" />
          Educational Platform
        </Badge>
      </div>

      {/* Trust Message */}
      <Card className="p-4 bg-gradient-to-r from-teen-green-bright/50 via-teen-blue-bright/30 to-teen-purple-bright/50 border-teen-green/30">
        <div className="text-center space-y-2">
          <div className="flex items-center justify-center gap-2 mb-2">
            <Heart className="w-4 h-4 text-teen-pink" />
            <span className="text-sm font-semibold text-foreground">Made with Care for Young Chess Players</span>
            <Heart className="w-4 h-4 text-teen-pink" />
          </div>
          <p className="text-xs text-muted-foreground">
            We never sell your data • Parent-approved content • Ad-free learning environment
          </p>
          <div className="flex items-center justify-center gap-4 text-xs text-muted-foreground mt-2">
            <span className="flex items-center gap-1">
              <Clock className="w-3 h-3" />
              24/7 Safe Environment
            </span>
            <span className="flex items-center gap-1">
              <Shield className="w-3 h-3" />
              Cloudflare Protected
            </span>
          </div>
        </div>
      </Card>
    </div>
  );
}